import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import { CircularProgress, styled } from 'netline-ui';

import styles, { loadingProgressClasses } from './LoadingProgress.styles';

const LoadingProgressRoot = styled('div', { name: loadingProgressClasses.$name })(styles);
type LoadingProgressProps = {
  className?: string;
  children?: React.ReactNode;
};

const LoadingProgress = ({ className, children }: LoadingProgressProps) => {
  return (
    <LoadingProgressRoot className={clsx(loadingProgressClasses.root, className)}>
      <CircularProgress className={loadingProgressClasses.progress} variant="indeterminate" size={32} />
      {children && <div className={loadingProgressClasses.text}>{children}</div>}
    </LoadingProgressRoot>
  );
};

LoadingProgress.propTypes = {
  children: PropTypes.node,
};

export default LoadingProgress;
